import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxTreeViewComponent } from 'devextreme-angular';
import { AppEventService, DataCacheService, AppEvent } from 'pumpcalc-core';

@Component({
  selector: 'app-list-dialogue',
  templateUrl: './list-dialogue.component.html',
  styleUrls: ['./list-dialogue.component.css']
})
export class ListDialogueComponent implements OnInit {

  @Input() title:string;
  @Input() list:any[] = [];
  @ViewChild("tree") tree:DxTreeViewComponent;
  lastSelected;  
  show=false;
  selectEnabled=false;
  context;
  lastRequest;


  constructor(private appEventService:AppEventService, private dataCacheService:DataCacheService) {
   this.appEventService.events.subscribe((event:AppEvent)=>{
      if(event.name=="OPEN_LIST"){
         this.lastRequest=event;
         this.list=this.dataCacheService.get(event.context);
         this.show=true;
         this.selectEnabled=false;
         this.context = event.context;
         this.title=this.context=="Pumpset"?"Select a pumpset to customise":"Select " + this.context;
      }
   })
  }

  ngOnInit(): void {
  }

  selectItem(event){
    if(event.itemData.name){
      this.lastSelected=event.itemData;
      this.selectEnabled=true;            
    }
  }

  select(){
     this.appEventService.emit({name:"SELECTION",context:this.context,data:this.lastSelected,parameters:this.lastRequest.parameters});
     this.show=false;
  }

  cancel(){
     this.show=false;
  }

  whenShowing(){
    if(this.tree){this.tree.searchValue=""}    
    this.lastSelected=null;
  }

}




